import React from 'react';
import type { ImageInitialModel } from '@src/utils/formatImage';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { showPic } from '../utils';

type PicProps = {
    content: {
        images: ImageInitialModel[];
        isComment?: boolean;
    };
};

const getLayout = ({ width, height }: { width?: number | null; height?: number | null }) => {
    let aspectRatio: number;
    let wrapClass: string;
    let isAutoSize = false;

    // 单图
    if (width && height) {
        // 当宽高均存在时，需要对宽高进行处理
        // 宽高比
        const rate = width / height;

        if (rate <= 3 / 4) {
            // 当宽高比小于等于3/4时，图片过高，此时需要将图片限制在3/4的宽高比上
            aspectRatio = 3 / 4;
            wrapClass = styles.wrapVertical;
        } else if (rate >= 16 / 9) {
            // 当宽高比大于16 / 9时，图片过宽，此时需要将图片限制到16/9的宽高比上
            aspectRatio = 16 / 9;
            wrapClass = styles.wrapHorizontal;
        } else {
            // 当图片处于非过高或过宽的情况下，展示原图比例
            aspectRatio = rate;
            wrapClass = styles.wrapAuto;
            isAutoSize = true;
        }
    } else {
        // 当无法获取宽高时，按16 / 9进行裁图
        aspectRatio = 16 / 9;
        wrapClass = styles.wrapHorizontal;
    }

    const paddingTop = `${(1 / aspectRatio) * 100}%`;

    return {
        wrapClass,
        isAutoSize,
        sizerStyle: {
            paddingTop,
        },
    };
};

const PicOne: React.FC<PicProps> = ({ content }) => {
    const { images, isComment } = content;
    const [{ url, width, height }] = images;
    const { wrapClass, isAutoSize, sizerStyle } = getLayout({ width, height });

    return isComment ? (
        <div className={`${styles.wrap} ${wrapClass}`}>
            {isAutoSize ? <div style={sizerStyle} /> : null}
            <div
                className={styles.thumbnailWrap}
                onClick={() => {
                    showPic({ images, index: 0 });
                }}>
                <img src={url} alt="" className={styles.thumbnail} />
            </div>
        </div>
    ) : (
        <div className={styles.wrap}>
            <div style={sizerStyle} />
            <div
                className={styles.thumbnailWrap}
                onClick={() => {
                    showPic({ images, index: 0 });
                }}>
                <img src={url} alt="" className={styles.thumbnail} />
            </div>
        </div>
    );
};

export default errorBoundary(PicOne);
